import { c as _c } from "react/compiler-runtime";
import React from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import ContactBtns from '../../consumer-new-footer/components/ContactBtns';
const DSRSuccess = () => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1><IconMaterialsDesigned color="#6bb7bf" className="w-11 h-auto mr-3.5 relative top-1" />Your request has been successfully sent.</h1>;
    t1 = <h3 className="max-md:mt-2 max-md:mx-0 max-md:mb-3">We will contact you in the next 45 days with next steps.</h3>;
    t2 = <div className="text-base">If you have any questions or concerns, please contact us directly. We're available by phone (888.282.0842) M-F 5:30am - 6pm PST, and S-S 7:30am PST.</div>;
    t3 = <ContactBtns variant="dsr" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="dsr-section">{t0}{t1}{t2}{t3}<div className="text-base">In the meantime, <CtaLink to="/customer-photos/" color="brand" hasArrow={false} noLinkPadding={true}>start getting inspired</CtaLink> for your next project!</div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default DSRSuccess;